<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Provider</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createOperation">
            Create
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
          >
            Cancel
          </el-button>
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input v-model="createForm.name" placeholder="Name">
            <template slot="prefix">Name</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
      </div>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input
            v-model="createForm.digitsToAdd"
            placeholder="Digits To Add"
          >
            <template slot="prefix">Digits To Add</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-input
            v-model.number="createForm.digitsToDelete"
            type="number"
            placeholder="DigitsToDelete"
            @input="checkForPositiveNumber"
          >
            <template slot="prefix">DigitsToDelete</template>
          </el-input>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-col :span="12">
          <h2 class="form-section-header">Host IP address</h2>
          <el-input v-model="createForm.host" placeholder="IP Address">
            <template slot="prefix">Host IP addresses</template>
          </el-input>
        </el-col>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { debounce } from "lodash";

export default {
  name: "ProvidersCreateForm",

  props: {
    createVisible: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true }
  },

  data() {
    return {
      createForm: {
        name: "",
        digitsToAdd: "",
        digitsToDelete: null,
        host: ""
      }
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    }
  },

  methods: {
    checkForPositiveNumber(num) {
      debounce(() => {
        if (num < 0) {
          this.createForm.digitsToDelete = null;
        }
      }, 300)();
    },

    createOperation() {
      const createBody = { ...this.createForm };
      const { digitsToDelete } = createBody;

      createBody.digitsToDelete = digitsToDelete ? digitsToDelete : 0;
      this.$emit("createOperation", createBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.createForm = {
        name: "",
        digitsToAdd: "",
        digitsToDelete: null,
        host: ""
      };
    }
  }
};
</script>
